import { createContext } from "react";

export type ToastType = "success" | "error" | "info" | "warning";

export interface Toast {
	title?: string;
	message: string;
	type: ToastType;
	onClick?(): unknown | Promise<unknown>;
	testId?: string;
	timeout?: number;
}

interface ToastContextProps {
	addToast: (data: Toast) => void;
}

const initialState = {
	addToast: () => undefined,
};

export const ToastContext = createContext<ToastContextProps>(initialState);
